import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const RangeForwardSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.28941 23.9435L12.5762 18.0226" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M33 11.3616L22.0973 17.1077H14.2587L12.5762 18.0226" stroke="#089981" strokeWidth="2"/>
    </svg>
)
const RangeForward: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {RangeForwardSvg(props)}
    </SvgIcon>
));
export default RangeForward